import {
  SafetyCertificateFilled,
  SafetyCertificateOutlined,
} from '@ant-design/icons';
import { Tooltip } from 'antd';

import type { FC } from 'react';

import '@app/components/RecordModal/components/RecordDetails/styles/PhoneVerifiedToggle.desktop.scss';

const PF = 'phone-verified-toggle';

type PhoneVerifiedTogglePropsType = {
  checked?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
};

export const PhoneVerifiedToggle: FC<PhoneVerifiedTogglePropsType> = ({
  checked = false,
  disabled = false,
  onChange,
}) => (
  <Tooltip title={checked ? 'Телефон подтверждён' : 'Телефон не подтверждён'}>
    <button
      type="button"
      className={`${PF}${checked ? ` ${PF}--checked` : ''}`}
      disabled={disabled}
      data-testid="phone-verified-toggle"
      onClick={() => onChange?.(!checked)}
    >
      {checked ? <SafetyCertificateFilled /> : <SafetyCertificateOutlined />}
    </button>
  </Tooltip>
);
